@if ({ selectedId: (selectedProjectors$ | async)?.uuid }; as obs) {
  <div class="dialog-container">
    <div class="dialog-header">
      <h1 class="dialog-title">
        {{ (obs.selectedId ? 'PROJECTOR.EDIT_PROJECTOR' : 'PROJECTOR.ADD_PROJECTOR') | translate }}
      </h1>
      <gb-icon [icon]="'close'" mat-dialog-close></gb-icon>
    </div>
    <form [formGroup]="addProjectorForm">
      <gb-form-field labelTranslateKey="PROJECTOR.PROJECTOR_NAME" [control]="projector_name"></gb-form-field>
      @if (!obs.selectedId && !!shouldShowTemplates) {
        <gb-select-form-field
          [control]="template_uuid"
          labelTranslateKey="PROJECTOR.PROJECTOR_TEMPLATE"
          [options$]="templateOptions$"
          displayProperty="name"
          valueProperty="value"
        ></gb-select-form-field>
      }
      <button [disabled]="(editCreateLoaded$ | async) === false" mat-flat-button (click)="submit()">
        <gb-button-loader [loaded$]="editCreateLoaded$">
          <span>{{ 'PROJECTOR.DONE' | translate }}</span>
        </gb-button-loader>
      </button>
    </form>
  </div>
}
